import { Button, styled } from '@ethings/ui-toolkit';
import { FC, useRef } from 'react';
import { disableClickPropagation } from '../../util';

const StyledButton = styled(Button)({
  minWidth: '32px !important',
  padding: 1,
  zIndex: 500,
});

export const MapButton: FC = (props) => {
  const ref = useRef<HTMLButtonElement>(null);
  disableClickPropagation(ref);
  return (
    <StyledButton
      {...props}
      ref={ref}
      size="small"
      variant="outlined"
    />
  );
};
